import { render, staticRenderFns } from "./textSlicer.vue?vue&type=template&id=2c606bba&"
import script from "./textSlicer.vue?vue&type=script&lang=js&"
export * from "./textSlicer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports